import { useElements, useStripe } from "@stripe/react-stripe-js";
import { Dispatch, SetStateAction } from "react";
import { toast } from "react-hot-toast";
import OutlinedButton from "@/components/common/buttons/outlinedButton";
import CreditCardFormContainer from "@/components/serviceFlow/payments/addCreditCard/creditCardFormContainer";
import useAction from "@/hooks/misc/useAction";
import useCreditCardActions from "@/hooks/serviceFlow/wallet/useCreditCardActions";

type Props = {
  clientId?: string;
  setNewCardsAsDefault: boolean;
  isAnyCardDefault?: boolean;
  showDrawer: boolean;
  setShowDrawer: Dispatch<SetStateAction<boolean>>;
};

export default function AddNewCreditCardSection({
  clientId: clientIdFromProps,
  setNewCardsAsDefault = false,
  isAnyCardDefault = false,
  showDrawer,
  setShowDrawer,
}: Props) {
  const { handleAddCard } = useCreditCardActions(clientIdFromProps);
  const { handleAction: addCardAction, isLoading } = useAction(handleAddCard);
  const stripe = useStripe();
  const elements = useElements();

  const handleShowCardDrawer = () => {
    if (!stripe) {
      toast.error("Stripe account for this MedSpa is not set up.");
      return;
    }
    setShowDrawer(true);
  };

  const buttonTitle = setNewCardsAsDefault
    ? isAnyCardDefault
      ? "Change default"
      : "Add a default card"
    : "Add a new card";

  return (
    <>
      <OutlinedButton
        small
        text={buttonTitle}
        sx={{ height: "45px", mt: 3, width: "100%" }}
        onClick={handleShowCardDrawer}
      />
      {stripe && elements && (
        <CreditCardFormContainer
          isOpen={showDrawer}
          setIsOpen={setShowDrawer}
          onConfirm={({ zipCode }) =>
            addCardAction({
              zipCode,
              setShowAddNewCardDrawer: setShowDrawer,
              setNewCardsAsDefault,
            })
          }
          actionPending={isLoading}
          shouldAskForSavingCard={false}
          buttonTitle={buttonTitle}
        />
      )}
    </>
  );
}
